import { Button, Grid2, Tooltip } from "@mui/material";

interface Props {
	isManual: boolean;
	tooltip?: string;
}

export const ManualAutoButton = ({ isManual, tooltip = "Manual" }: Props) => {
	if (!isManual) return null;

	return (
		<Grid2 container justifyContent="center" alignItems="center" height="100%">
			<Tooltip title={tooltip} arrow>
				<Button
					variant="contained"
					color="primary"
					sx={{
						minWidth: "25px",
						width: "25px",
						height: "25px",
						minHeight: "25px",
						maxHeight: "25px",
						padding: 0,
						lineHeight: 1,
						fontSize: "0.875rem",
						cursor: "default",
						"&:hover": {
							cursor: "default",
						},
					}}
				>
					M
				</Button>
			</Tooltip>
		</Grid2>
	);
};
